<template>
  <div class="privatstep1">

        <base-data state-path="b"/>

        <v-row no-gutters class="stepperbuttons">
          <v-spacer/>
          <v-btn v-if="!hideNext" id="next1"
                 color="primary"
                 class="standard-button"
                 @click="$emit('step-forward')">Weiter</v-btn>
        </v-row>

  </div>
</template>

<script>
import BaseData from "@/components/privatkundenrechner/BaseData";

export default {
  name: "PrivatStep1",
  components: { BaseData },
  props: {
    hideNext: {
      type: Boolean,
      default: false
    }
  },
  mounted: function() {
            this.$store.dispatch('INIT_PRAEMIEN', this.$store.getters.tarifToLoad)
            .catch((err) => {
              console.log('emit load-tarif-error');
              this.$emit('load-tarif-error', { message: "Keine Netzwerkverbindung, Beiträge konnten nicht geladen werden", raw: err });
            });

  }
};  
</script>
